// @ts-nocheck
import classNames from 'classnames';

interface ShimmerButtonProps
    extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    children: React.ReactNode;
    className?: string;
}

export default function ShimmerButton({
    children,
    className,
    disabled,
    onClick,
    ...props
}: ShimmerButtonProps) {
    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        onClick?.(e);
    };

    return (
        <button
            className={classNames(
                'relative px-8 py-4 font-semibold text-white transition-all duration-300 overflow-hidden group',
                'bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg',
                'hover:shadow-2xl hover:scale-105 hover:from-purple-700 hover:to-pink-700',
                'disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100',
                'shadow-lg',
                className
            )}
            disabled={disabled}
            onClick={handleClick}
            style={{
                boxShadow:
                    '0 4px 15px 0 rgba(168, 85, 247, 0.4), 0 8px 30px 0 rgba(236, 72, 153, 0.3)',
            }}
            {...props}
        >
            {/* Glow effect on hover */}
            <div className="absolute inset-0 rounded-lg bg-gradient-to-r from-purple-600 to-pink-600 opacity-0 group-hover:opacity-20 transition-opacity duration-300" />

            {/* Content */}
            <span className="relative z-10">{children}</span>
        </button>
    );
}
